import { SalesforceEvent } from '../types';

/**
 * Service for fetching Salesforce data
 */
class SalesforceService {
  /**
   * Fetch Salesforce events for the logged-in user from the past 30 days
   */
  async fetchEvents(): Promise<SalesforceEvent[]> {
    try {
      const response = await fetch('/api/internal/salesforce/events', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch events: ${response.statusText}`);
      }

      const result = await response.json();
      
      if (!result.success || !result.data) {
        throw new Error('Invalid response from events API');
      }

      return result.data;
    } catch (error) {
      console.error('Error fetching Salesforce events:', error);
      throw error;
    }
  }
}

export const salesforceService = new SalesforceService();

